import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Spin } from "antd";
import AWS from "aws-sdk";

import Swal from "sweetalert2";

import inquiryApi from "../../apis/Inquiry.api";
import { toastAlert } from "../../components/AlertComponent";
import InquiryManageEachAnswer from "../../components/edit/inquiryManage/inquiryManageEachAnswer";
import InquiryManageEachQuestion from "../../components/edit/inquiryManage/inquiryManageEachQuestion";
import LinkComponent from "../../components/layout/LinkComponent";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();

const InquiryManageDetail = (props) => {
	const inquiryId = props.match.params?.id;
	const history = useHistory();
	const dispatch = useDispatch();
	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [inquiryValue, setInquiryValue] = useState({});

	const [inquiryImageList, setInquiryImageList] = useState([]);
	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);

	useEffect(() => {
		if (inquiryValue?.answer) {
			setAnswerValue(inquiryValue.answer);
			setImageList(inquiryValue.answer?.imageList);
		}
	}, [inquiryValue]);

	const [answerValue, setAnswerValue] = useState({
		title: null,
		content: null,
		is_secret: false,
	});
	const [biggestTitle, setBiggestTitle] = useState(0);

	useEffect(() => {
		if (!!inquiryId && !!user?.id) {
			getInquiryBoard();
		}
	}, [inquiryId, user]);

	/**
	 * 상담게시글 단건 조회
	 * @returns {Promise<void>}
	 */
	const getInquiryBoard = async () => {
		const param = {
			inquiryId: inquiryId,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			// userId: user?.id
			userId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
		};

		const res = await inquiryApi.readInquiryBoard(param);

		if (res.code === 200) {
			setInquiryValue(res.result?.inquiry);
			// 질문 이미지 리스트
			if (res.result?.inquiryImageList?.length > 0) {
				let list = [];
				let photos = [];
				for (let i = 0; i < res.result?.inquiryImageList?.length; i++) {
					let resultImageList = res.result?.inquiryImageList[i];
					let source = `${
						process.env.REACT_APP_S3_HOST
					}/image/together/inquiry/board/${
						user?.role === "level_1" || user?.role === "super_admin"
							? user?.id
							: user?.partners_id
					}/${resultImageList?.title}.${resultImageList?.img_type}`;
					list.push(source);
					photos.push({
						source: source,
						type: `image/${resultImageList?.img_type}`,
					});
				}
				// 최대 5개까지
				setInquiryImageList(list.slice(0, 5));
			} else {
				setInquiryImageList([]);
			}
			// 답변 이미지 리스트
			if (res.result?.answerImageList?.length > 0) {
				// 타이틀 중 가장 큰 값 저장
				let bigTitle =
					res.result?.answerImageList
						?.reduce((prev, value) => {
							return prev?.title?.split("-")?.[1] >=
								value?.title?.split("-")?.[1]
								? prev
								: value;
						})
						?.title?.split("-")?.[1] ?? 0;
				setBiggestTitle(bigTitle ? Number(bigTitle) : 0);

				let list = [];
				let photos = [];
				for (let i = 0; i < res.result?.answerImageList?.length; i++) {
					let resultImageList = res.result?.answerImageList[i];
					let source = `${
						process.env.REACT_APP_S3_HOST
					}/image/together/inquiry/answer/${
						user?.role === "level_1" || user?.role === "super_admin"
							? user?.id
							: user?.partners_id
					}/${resultImageList?.title}.${resultImageList?.img_type}`;
					list.push(source);
					photos.push({
						title: resultImageList?.title,
						source: source,
						type: `image/${resultImageList?.img_type}`,
					});
				}
				// 최대 5개까지
				setImageList(list.slice(0, 5));
				setPhotoList(photos.slice(0, 5));
			} else {
				setImageList([]);
				setPhotoList([]);
			}

			// 답변 내용
			setAnswerValue(res.result?.answer ?? {});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("get-inquiry-each-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 목록으로
	 */
	const goBackToList = () => {
		if (!!answerValue.title?.length || !!answerValue.content?.length) {
			Swal.fire({
				customClass: "alert-custom",
				text: `작성하던 글이 있습니다. 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					history.replace(`/inquiry_manage`);
				}
			});
		} else {
			history.replace(`/inquiry_manage`);
		}
	};

	/**
	 * 작성 완료
	 */
	const submitInquiryAnswer = async () => {
		if (
			!answerValue?.title?.replaceAll(" ", "")?.length ||
			!answerValue?.content?.replaceAll(" ", "")?.length
		) {
			toastAlert("질문과 내용을 모두 작성해주세요.");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "작성을 완료하고 적용하시겠습니까?",
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setIsLoading(true);
					let param = {
						inquiry_id: inquiryId,
						title: answerValue?.title,
						content: answerValue?.content,
						created_by: user?.id,
					};
					if (answerValue?.id) {
						param = {
							...param,
							id: answerValue.id,
						};
					}
					const res = await inquiryApi.adminPostInquiry(param);
					if (res.code === 200) {
						addInquiryImageList(res.result);
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
							confirmButtonText: "확인",
						}).then(() => {
							console.log("post-inquiry-error");
							setIsLoading(false);
						});
					}
				}
			});
		}
	};

	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const addInquiryImageList = async (result) => {
		let list = [];
		for (let i = 0; i < photoList?.length; i++) {
			let photo = photoList[i];

			if (photo?.file) {
				uploadToS3(result, photo, i);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			} else {
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: photo?.title ?? `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
				});
			}
		}

		if (list?.length) {
			const param = {
				id: inquiryId,
				influencerId:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
				is_inquiry: false,
				// created_by: user?.id,
				created_by:
					user?.role === "level_1" || user?.role === "super_admin"
						? user?.id
						: user?.partners_id,
				inquiryImageList: [],
				answerImageList: [...list],
			};

			const res = await inquiryApi.postInquiryImages(param);
			if (res.code === 200) {
				Swal.fire({
					customClass: "alert-custom",
					text: "성공적으로 적용되었습니다!",
					confirmButtonText: "확인",
				}).then(() => {
					history.replace(`/inquiry_manage`);
					setIsLoading(false);
				});
			} else {
				Swal.fire({
					customClass: "alert-custom",
					text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
					confirmButtonText: "확인",
				}).then(() => {
					console.log("inquiry-image-list-error");
					setIsLoading(false);
				});
			}
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 적용되었습니다!",
				confirmButtonText: "확인",
			}).then(() => {
				history.replace(`/inquiry_manage`);
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param result
	 * @param photo
	 * @param i
	 * @returns {Promise<void>}
	 */
	const uploadToS3 = async (result, photo, i) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path = `image/together/inquiry/answer/${
			user?.role === "level_1" || user?.role === "super_admin"
				? user?.id
				: user?.partners_id
		}/${result?.id}-${biggestTitle + i + 1}.${fileType}`;

		//aws-sdk 사용
		let params = {
			Bucket: process.env.REACT_APP_S3_BUCKETNAME,
			Key: s3Path,
			Body: photo.file,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("inquiry-s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("inquiry-s3-upload-error");
				setIsLoading(false);
			});
		}
	};

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />

				{/* 추천 상담 게시판 */}
				{isLoading && (
					<Spin
						style={{
							margin: "auto",
							width: "100%",
							paddingTop: "2em",
							position: "absolute",
							left: 0,
							right: 0,
						}}
					/>
				)}
				<div className={`main-body`}>
					<div
						style={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
						}}
					>
						<h3 className={`body-title`}>
							{inquiryValue?.answer?.title ? "답변 수정하기" : "답변하기"}
						</h3>
					</div>
					<div className={`inquiry-manage-each-body`}>
						<InquiryManageEachQuestion
							inquiryValue={inquiryValue}
							inquiryImageList={inquiryImageList}
						/>
						<InquiryManageEachAnswer
							inquiryId={inquiryId}
							getInquiryBoard={getInquiryBoard}
							imageList={imageList}
							setImageList={setImageList}
							photoList={photoList}
							setPhotoList={setPhotoList}
							answerValue={answerValue}
							setAnswerValue={setAnswerValue}
						/>
						<div className={`inquiry-manage-each-button-group`}>
							<Button onClick={goBackToList} loading={isLoading}>
								목록으로
							</Button>
							<Button
								className={`success`}
								onClick={submitInquiryAnswer}
								loading={isLoading}
							>
								{answerValue?.id ? "수정하기" : "작성완료"}
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default InquiryManageDetail;
